var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThunder = function SvgThunder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.668 5.334H4.934L7.95.51A.333.333 0 0 0 7.668 0H2.334a.334.334 0 0 0-.324.253l-2 8a.34.34 0 0 0 .06.287c.064.08.16.128.263.128h2.23L.68 15.58a.33.33 0 0 0 .183.392c.15.065.323.015.415-.12l6.668-10a.334.334 0 0 0-.277-.518z"
  })));
};
export default SvgThunder;